// extracted by mini-css-extract-plugin
export var content = "_nj-1";
export var fullScreen = "_nj-0";